import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { ApiErrorService } from '../services/api-error.service';
import { PermissionService } from '../services/permission.service';

export const AuthGuard: CanActivateFn = async (route, state) => {
  const permissionService = inject(PermissionService);

  return permissionService.ensureAuthenticated();
};

export const PermissionGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const permissionService = inject(PermissionService);
  const apiErrorService = inject(ApiErrorService);

  const isAuthenticated = await permissionService.ensureAuthenticated();
  if (!isAuthenticated) {
    return false;
  }

  const requiredPermission = route.data?.['permission'];
  if (!requiredPermission || permissionService.hasPermission(requiredPermission)) {
    return true;
  }

  apiErrorService.setError({
    status: 403,
    title: 'Permission denied',
    detail: `Missing required permission: ${requiredPermission}`,
  });

  return router.createUrlTree(['/home']);
};
